import { ProcesName } from '../../../containers/helpers/ProcesHandlerHelpers';
import { IFormConfig, ProcesHandler } from '../../../interfaces/FormConfig';
import { FormProps, FormState } from '../../../containers/FormContainer';

export class LidZoekenResultaatHelpers {
  static getProcesses(formConfig: IFormConfig): ProcesHandler[] {
      if (formConfig.procesHandlers !== 'lidzoekenresultaat') {
          return [];
      }
      return [
        {
            // PUT, before
            procesName: ProcesName.Put_preprocess,
            execute: (
                component: React.Component<FormProps, FormState>,
                data: any,
                onSuccess,
                onError
            ) => {
                const index = (component.props.formConfig as any).index;
                if (component.props.formConfig && component.props.formConfig.receiveFieldsViaGlobalState) {
                    component.props.formConfig.receiveFieldsViaGlobalState.map((passThroughFieldName) => {
                        if (component.props.lidZoeken.additionalFormData[passThroughFieldName]) {
                            if (component.props.lidZoeken.additionalFormData[passThroughFieldName].value) {
                                data[passThroughFieldName] = component.props.lidZoeken.additionalFormData[passThroughFieldName].value;
                            } else {
                                data[passThroughFieldName] = component.props.lidZoeken.additionalFormData[passThroughFieldName];
                            }
                        }
                    });
                }
                // Always call back to enable next step in process
                onSuccess(data);
            }
        },          
        {
            // PUT when done
            procesName: ProcesName.Put_postprocess_Success,
            execute: (
                component: React.Component<FormProps, FormState>,
                data: any,
                onSuccess,
                onError
            ) => {
                
                component.setState({
                    isSubmitting: false,
                    isShowPostOk: true,
                    showThanksMessageAsInPageContent: false
                }, () => {
                    //component.props.clearLidZoeken();
                    onSuccess({
                        isPreventDefault: true
                    });
                });                                                                                    
            }
        },          
        {
            // PUT when done
            procesName: ProcesName.Put_postprocess_Fail,
            execute: (
                component: React.Component<FormProps, FormState>,
                data: any,
                resolve,
                reject
            ) => {
                if (data.responseText !== undefined) {
                    try {
                        let error = JSON.parse(data.responseText);
                        component.setState({
                            isShowPostDataError: true, 
                            isSubmitting: false,
                            isUserError: !!error.IsUserError,
                            popupMessageOnFailure : error.ErrorText || ""
                        });
                        resolve({}); 
                    } catch {
                        // skip
                    }
                }
                component.setState({
                    isShowPostDataError: true, 
                    isSubmitting: false 
                });
                resolve({});                                                      
            }
        }, 
        {
            procesName: ProcesName.PopupOnOk,
            execute: (
                component: React.Component<FormProps, FormState>,
                data: any,
                onSuccess,
                reject
            ) => {
                if (component.props.formConfig.linkedForm && component.props.formConfig.clearFields) {
                    if (component.props.forms[component.props.formConfig.linkedForm]) {
                        let form = component.props.forms[component.props.formConfig.linkedForm];
                        component.props.formConfig.clearFields.map(fieldName => {
                            form[fieldName] = "";
                        });
                        component.props.setFormValues(component.props.formConfig.linkedForm, {...form});                    
                    }
                }
               
                if (component.props.formConfig.scrollTo) {
                    const scrollIntoViewElement = document.getElementById(component.props.formConfig.scrollTo);
                    if (scrollIntoViewElement) {
                        scrollIntoViewElement.scrollIntoView();
                    }
                }
                
                component.props.clearLidZoeken();
                onSuccess({});                                                     
            }
        },
        {
            procesName: ProcesName.CancelForm,
            execute: (
                component: React.Component<FormProps, FormState>,
                data: any,
                onSuccess,
                reject
            ) => {
                if (component.props.formConfig.linkedForm && component.props.formConfig.clearFields) {
                    if (component.props.forms[component.props.formConfig.linkedForm]) {
                        let form = component.props.forms[component.props.formConfig.linkedForm];
                        component.props.formConfig.clearFields.map(fieldName => {
                            form[fieldName] = "";
                        });
                        component.props.setFormValues(component.props.formConfig.linkedForm, {...form});                    
                    }
                }
               
                if (component.props.formConfig.scrollTo) {
                    const scrollIntoViewElement = document.getElementById(component.props.formConfig.scrollTo);
                    if (scrollIntoViewElement) {
                        scrollIntoViewElement.scrollIntoView();
                    }
                }
                
                component.props.clearLidZoeken();
                onSuccess({});                                                     
            }
        }
      ];
  }
}